module.exports = __webpack_public_path__ + "static/img/ic_convience@2x.1fbeaa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_convience@2x.png
// module id = TEeV
// module chunks = 1